import React from 'react'
import ReduxStores from '../../../../stores/connects'
import classNames from 'classnames'
import { string } from 'prop-types'

class BookingsDropdown extends React.Component {
  render () {
    const { loggedInData, customClass = '', pageName = '' } = this.props

    if (!loggedInData.first_name) return null

    const buttonText = 'Your bookings'
    const buttonClasses = classNames({
      'btn': true,
      'nav-cta-button': true,
      'bookings-button': true,
      'btn-secondary': true
    }, customClass)

    return (
      <a data-track-name='your_bookings_link_clicked' data-track-value={pageName} href='https://v2.holidayextras.co.uk/static/#/mytrips' className={buttonClasses} type='button'>
        { buttonText }
      </a>
    )
  }
}

BookingsDropdown.propTypes = {
  customClass: string,
  pageName: string
}

export default ReduxStores(BookingsDropdown, ['login'], true)
